import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PreviewContext } from '../preview.types';
import { getFooterPreviewData } from '../preview-style.resolver';

@Component({
  selector: 'app-footer-section-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer-section-preview.html',
  styleUrl: './footer-section-preview.scss',
})
export class FooterSectionPreviewComponent {
  @Input() context: PreviewContext | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';

  get data() {
    return getFooterPreviewData(this.context);
  }
}
